import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompanyService {
    /**
     * Get company by ID
     * @param id
     * @returns CompanyBoInterface
     * @throws ApiError
     */
    static companyFindById(id) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/company/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update company by ID
     * @param id
     * @param requestBody
     * @returns CompanyBoInterface
     * @throws ApiError
     */
    static companyUpdate(id, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/company/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Find company members by company ID
     * @param id
     * @returns CompanyMembersBoInterface
     * @throws ApiError
     */
    static companyFindMembersById(id) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/company/{id}/members',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Bulk update company members by company ID
     * @param id
     * @param requestBody
     * @returns BulkCompanyMemberUpsertResponseBoInterface
     * @throws ApiError
     */
    static companyUpdateMembers(id, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/company/{id}/members',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Find user role for member by company ID
     * @param id
     * @returns CompanyMemberRoleBoInterface
     * @throws ApiError
     */
    static companyFindUserRole(id) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/company/{id}/role',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Change user role
     * @param id
     * @param userId
     * @param requestBody
     * @returns CompanyMemberBoInterface
     * @throws ApiError
     */
    static companyChangeRole(id, userId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/company/{id}/members/{userId}/role',
            path: {
                'id': id,
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
